import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../shadcn-ui/card';
import { Label } from '../shadcn-ui/label';
import { Input } from '../shadcn-ui/input';
import { Minus, Plus } from 'lucide-react';
import { Button } from '../shadcn-ui/button';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../shadcn-ui/select';
import { useMasterStore } from '@/stores/useMaster.store';

const EstateVarietalCard = ({ loading }) => {
  const varietalList = useMasterStore(state => state.varietalList);
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  // varietal_details field array
  const {
    fields: varietalFields,
    append: appendVarietal,
    remove: removeVarietal,
  } = useFieldArray({
    control,
    name: 'varietal_details',
  });

  return (
    <Card className="rounded-2xl border border-border shadow-sm">
      <CardHeader className="px-4 pb-3">
        <CardTitle className="text-base font-medium">Varietal details</CardTitle>
      </CardHeader>

      <CardContent className="space-y-[22px] p-4 pt-0">
        <div className="space-y-2">
          <Label className="mb-1.5 text-sm font-normal text-[hsl(var(--text-foreground-secondary))]">
            Varietal details<span className="">*</span>
          </Label>

          <div className="space-y-3">
            {varietalFields?.map((field, idx) => (
              <div key={field.id} className="grid grid-cols-[1fr_1fr_max-content_max-content] items-start gap-2">
                <div className="flex-1 rounded-[10px]">
                  <Controller
                    name={`varietal_details.${idx}.varietal`}
                    control={control}
                    render={({ field }) => (
                      <Select value={field.value} onValueChange={field.onChange} disabled={loading}>
                        <SelectTrigger className="rounded-[10px] bg-white text-sm">
                          <SelectValue placeholder="Select varietal" />
                        </SelectTrigger>
                        <SelectContent>
                          {varietalList?.map(({ varietal, _id }) => (
                            <SelectItem key={_id} value={varietal}>
                              {varietal}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    )}
                  />

                  {errors?.varietal_details?.[idx]?.varietal && (
                    <div className="mt-1 text-xs text-red-500">{errors.varietal_details[idx].varietal.message}</div>
                  )}
                </div>

                <div className="rounded-[10px]">
                  <Input
                    disabled={loading}
                    className="rounded-[10px] bg-white text-sm"
                    type="number"
                    inputMode="decimal"
                    step="0.01"
                    placeholder="Area"
                    {...register(`varietal_details.${idx}.area_in_acres`)}
                  />

                  {errors?.varietal_details?.[idx]?.area_in_acres && (
                    <div className="mt-1 text-xs text-red-500">
                      {errors.varietal_details[idx].area_in_acres.message}
                    </div>
                  )}
                </div>

                {/* Add / Remove Button */}
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => removeVarietal(idx)}
                  disabled={varietalFields.length === 1}
                >
                  <Minus className="h-4 w-4" />
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => appendVarietal({ varietal: '', area_in_acres: '' })}
                >
                  <Plus className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EstateVarietalCard;
